<template>
  <div class="page-box">
    <div class="top">
      <el-form ref="form" :model="form" label-width="85px" inline style="display: flex; align-items: center">
        <el-form-item label="时间范围：">
          <el-date-picker
              class="data-picker"
              size="small"
              @change="init"
              v-model="searchForm.time"
              :default-time="['00:00:00', '23:59:59']"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              :editable="false"
            >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="userDataBox">
        <div class="title">用户访问数据</div>
        <div class="textBox">
          <div class="overview-item">
            <div class="value">{{textForm.visitTotal || 0}}</div>
            <div class="label">累计用户数</div>
          </div>
          <div class="overview-item leftBorder">
            <div class="value">{{textForm.sharePv || 0}}</div>
            <div class="label">转发次数</div>
          </div>
          <div class="overview-item leftBorder">
            <div class="value">{{textForm.shareUv || 0}}</div>
            <div class="label">转发人数</div>
          </div>
        </div>
      </div>
      <div class="userTrendBox">
        <div class="title">用户访问趋势</div>
        <div class="bthBox">
          <div class="left-bth">
            <span>指标筛选：</span>
            <div
              :class="`bth-style ${btnLeftIndex == index ? 'bth-style-ative' : ''}`"
              v-for="(item, index) in ['访问人数', '打开次数', '访问次数', '新用户数']"
              :key="index"
              @click="indicatorScreening(item, index)"
            >
              {{ item }}
            </div>
          </div>
          <div class="right-bth">
            <span>趋势筛选：</span>
            <div
              :class="`bth-style ${btnRightIndex == index ? 'bth-style-ative' : ''}`"
              v-for="(item, index) in ['日趋势', '周趋势', '月趋势']"
              :key="index"
              @click="trendFiltering(item, index)"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="center-chats" ref="lineChats" v-loading="loading"></div>
      </div>
      <div>
        <div class="title">用户地域画像</div>
        <div class="userRegional">
          <div class="leftBox">
            <div class="tableTitle">省级地域分布</div>
            <el-table stripe v-loading="loading3" ref="tableRef" highlight-current-row border :data="tableData" height="200px">
              <el-table-column prop="name" label="省份" align="center"></el-table-column>
              <el-table-column prop="visitNum" label="访问人数" align="center"></el-table-column>
              <el-table-column prop="proportion" label="占比" align="center">
                <template slot-scope="{row}">
                  {{row.proportion + '%'}}
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 20px">
              <el-pagination
                @size-change="onSizeChange"
                @current-change="onNumChange"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                :page-sizes="[10, 20, 50]"
                layout="total, sizes, prev, pager, next, jumper"
              >
              </el-pagination>
            </div>
          </div>
          <div class="rightBox">
            <div class="tableTitle">市级地域分布
              <span class="label">省份选择</span>
              <el-select v-model="searchForm.proportionId" placeholder="请选择" size="small" @change="visitAreaList(true)">
                <el-option v-for="item in provinceList" :key="item.proportionId" :label="item.name" :value="item.proportionId"> </el-option>
              </el-select>
            </div>
            <el-table stripe v-loading="loading2" ref="tableRef" highlight-current-row border :data="tableData2" height="200px">
              <el-table-column prop="name" label="市级" align="center"></el-table-column>
              <el-table-column prop="visitNum" label="访问人数" align="center"></el-table-column>
              <el-table-column prop="proportion" label="占比" align="center">
                <template slot-scope="{row}">
                  {{row.proportion + '%'}}
                </template>
              </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 20px">
              <el-pagination
                @size-change="onSizeChange2"
                @current-change="onNumChange2"
                :current-page="pageNum2"
                :page-size="pageSize2"
                :total="total2"
                :page-sizes="[10, 20, 50]"
                layout="total, sizes, prev, pager, next, jumper"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="title">用户属性画像</div>
        <div class="userAttribute">
          <div class="leftBox" ref="barChats"></div>
          <div class="rightBox" ref="pieChats"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import barChats from "./mixins/barChats.mixin";
import pieChats from "./mixins/pieChats.mixin";
import lineChats from "./mixins/lineChats.mixin";
import moment from 'moment'
export default {
  name: "WeChatData",
  mixins: [lineChats, barChats, pieChats],
  components: {},
  data() {
    return {
      value: "",
      value1: "",
      radio3: "",
      radio4: "全部",
      activeName: "",
      form: {},
      btnIndex: 0,
      btnLeftIndex: 0,
      btnRightIndex: 0,
      loading: false,
      searchForm: {
        time: [moment().subtract(1, "months").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")],
        proportionId: ''
      },
      textForm: {},
      // 表格相关
      tableData: [],
      tableData2: [],
      selection: [],
      provinceList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      pageSize2: 10,
      pageNum2: 1,
      total2: 0,
      loadingIndex: 0,
      loadingAll: false,
      loading1: false,
      loading2: false,
      loading3: false,
    };
  },
  mounted() {
    this.wxMiniProvinceList()
  },
  watch: {
    loadingIndex(val,old) {
      if(val == 6) {
        setTimeout(() => {
          this.loadingAll.close()
        }, 500);
      }
    }
  },
  methods: {
    init() {
      this.loadingIndex = 0
      this.loadingAll = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(255, 255, 255, 0.7)",
    });
      this.wxMiniVisitTotal()
      this.wxMiniVisitTrend()
      this.wxMiniVisitAreaList()
      this.visitAreaList()
      this.wxMiniVisitAgeList()
      this.wxMiniVisitGenderList()
    },
    wxMiniVisitTotal() {
      let { time } = this.searchForm
      let data = {
        startTime: time ? time[0] : '',
        endTime: time ? time[1] : '',
      }
      this.$api.home.wxMiniVisitTotal(data).then((res) => {
        this.textForm = res.data || {}
      }).finally(_=>{
        this.loadingIndex += 1
      });
    },
    //
    wxMiniVisitTrend() {
      this.loading = true
      let { time } = this.searchForm
      let data = {
        startTime: time ? time[0] : '',
        endTime: time ? time[1] : '',
        targetType: this.btnLeftIndex + 1,
        type: this.btnRightIndex + 1,
      }
      this.$api.home.wxMiniVisitTrend(data).then((res) => {
        this.render_line(res.data, this.btnRightIndex);
      }).finally(_=>{
        this.loadingIndex += 1
        this.loading = false
      });
    },
    wxMiniVisitAreaList() {
      this.loading3 = true
      let { time } = this.searchForm
      let data = {
        filterData: {
          startTime: time ? time[0] : '',
          endTime: time ? time[1] : '',
          provinceId: ''
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      this.$api.home.wxMiniVisitAreaList(data).then((res) => {
        this.total = res.data.total
        this.tableData = res.data.list
      }).finally(_=>{
        this.loadingIndex += 1
        this.loading3 = false
      });
    },
    visitAreaList(type) {
      if(type) {
        this.pageNum2 = 1
      }
      this.loading2 = true
      let { time, proportionId } = this.searchForm
      let data = {
        filterData: {
          startTime: time ? time[0] : '',
          endTime: time ? time[1] : '',
          provinceId: proportionId
        },
        pageNum: this.pageNum2,
        pageSize: this.pageSize2,
      }
      this.$api.home.wxMiniVisitAreaList(data).then((res) => {
        this.total2 = res.data.total
        this.tableData2 = res.data.list
      }).finally(_=>{
        this.loadingIndex += 1
        this.loading2 = false
      });
    },
    wxMiniProvinceList() {
      this.$api.home.wxMiniProvinceList().then((res) => {
        this.provinceList = res.data
        let proportionId = res.data.filter(v=>v.name.includes('四川'))[0].proportionId
        this.$set(this.searchForm,'proportionId',proportionId)
        this.init()
      });
    },
    wxMiniVisitAgeList() {
      let { time } = this.searchForm
      let data = {
        startTime: time ? time[0] : '',
        endTime: time ? time[1] : '',
      }
      this.$api.home.wxMiniVisitAgeList(data).then((res) => {
        this.render_bar(res.data);
      }).finally(_=>{
        this.loadingIndex += 1
      });
    },
    wxMiniVisitGenderList() {
      let { time } = this.searchForm
      let data = {
        startTime: time ? time[0] : '',
        endTime: time ? time[1] : '',
      }
      this.$api.home.wxMiniVisitGenderList(data).then((res) => {
        this.render_pie(res.data);
      }).finally(_=>{
        this.loadingIndex += 1
      });
    },
    indicatorScreening(item, index) {
      this.btnLeftIndex = index;
      this.wxMiniVisitTrend()
    },
    trendFiltering(item, index) {
      this.btnRightIndex = index;
      this.wxMiniVisitTrend()
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.wxMiniVisitAreaList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.wxMiniVisitAreaList();
    },
    onSizeChange2(pageSize) {
      this.pageSize2 = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum2 = 1;
      this.visitAreaList();
    },
    onNumChange2(pageNum) {
      this.pageNum2 = pageNum;
      this.visitAreaList();
    },
  },
};
</script>

<style lang="stylus" scoped>
.page-box {
  height: calc(100% - 30px);
  border-radius: 5px;
  margin: 5px;
  padding: 10px;
  background: #FFF;

  .title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .content {
    height: calc(100% - 50px);
    overflow: auto;

    .userDataBox{
      .textBox {
        height: 100px
        padding: 30px
        margin: 10px 10px 30px 10px
        background: #F2F2F2
        border-radius: 2px
        display: flex
        align-items: center
          .overview-item{
            flex: 1
            text-align: center
            line-height: 32px
              .label {
                font-size: 14px

              }
              .value {
                font-size: 26px
              }
          }
          .leftBorder {
            border-left: 1px #0BB78E solid
          }

      }
    }

    .userTrendBox {
      height: 350px;
      margin-bottom: 20px;

      .bthBox{
        display: flex
        align-items: center
        justify-content: space-between
        margin: 0 10px
          .bth-style {
            height: 40px;
            line-height: 40px;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 0 19px;
            color: rgba(0,0,0,.9);
            font-size: 14px;
            font-weight: 400;
            text-align: center;
            margin-left: 12px;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            border: 1px solid rgba(0,0,0,.05);
          }
          .bth-style:hover {
            background-color: rgba(0,0,0,.04)
            border: 1px solid transparent
          }
          .bth-style-ative {
            background-color: rgba(0,0,0,.04)
            border: 1px solid transparent
          }
      }

      .center-chats {
        width: calc(100% - 40px)
        height: calc(100% - 40px)
      }
    }
    .userRegional {
      width: calc(100% - 20px)
      margin-bottom: 20px;
      display: flex
      justify-content: space-between
        .leftBox {
          min-width: calc(50% - 20px)
          flex: 1
          padding-right: 20px
        }
        .rightBox {
          min-width: calc(50% - 20px)
          flex: 1
          padding-left: 20px
        }
        .tableTitle {
          height: 42px
          font-size: 15px
          line-height: 42px
            .label {
              display: inline-block
              padding: 0 10px 0 30px
            }
        }
    }
    .userAttribute {
      height: 320px
      display: flex
      margin-top: 30px
        .leftBox {
          flex: 1
        }
        .rightBox {
          flex: 1
        }
    }
  }
}

>>> .el-form-item {
  margin-bottom: 10px;
}

>>> .el-date-editor.el-input__inner {
  width: 260px;
}
</style>
